(function(){
  if (window.__rsBundleImageFallbackLoaded) return;
  window.__rsBundleImageFallbackLoaded = true;
  var cache = {};
  var SELECTOR = 'img.bogos-bundle-item-img, img.revy-bundle-image, img[class*="bundle"][src]';

  function cleanTitle(text){
    return (text || '').replace(/\[[^\]]*\]/g, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim();
  }

  function productImageUrl(product, img){
    if (!product || !product.image) return null;
    var url = product.image;
    if (img.className && String(img.className).indexOf('bogos-bundle-item-img') !== -1) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=90&height=90';
    }
    return url;
  }

  function pickProduct(products, title){
    if (!products || !products.length) return null;
    var target = cleanTitle(title).toLowerCase();
    var exact = products.find(function(p){ return cleanTitle(p.title).toLowerCase() === target; });
    return exact || products[0];
  }

  function searchProduct(title){
    title = cleanTitle(title);
    if (!title) return Promise.resolve(null);
    if (cache[title]) return cache[title];
    var url = '/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=5';
    cache[title] = fetch(url, { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        var products = data && data.resources && data.resources.results && data.resources.results.products;
        return pickProduct(products, title);
      })
      .catch(function(){ return null; });
    return cache[title];
  }

  function titleFromImage(img){
    var title = img.getAttribute('alt') || '';
    if (!title) {
      var node = img.closest('.bogos-bundle-item, .bogos-bundle-item-wrapper, .revy-bundle-product, [class*="bundle"]');
      if (node) title = (node.innerText || '').split('\n').filter(Boolean)[0] || '';
    }
    return title;
  }

  function fixImage(img){
    if (!img || img.dataset.rsFallbackTried === '1') return;
    img.dataset.rsFallbackTried = '1';
    var title = titleFromImage(img);
    searchProduct(title).then(function(product){
      var url = productImageUrl(product, img);
      if (!url) return;
      img.src = url;
      img.removeAttribute('srcset');
      img.style.visibility = '';
      if (!img.getAttribute('alt') && product.title) img.setAttribute('alt', product.title);
      if (window.console && console.info) console.info('[RS bundle fallback] fixed bundle image:', title, '=>', url);
    });
  }

  function bind(root){
    Array.prototype.forEach.call((root || document).querySelectorAll(SELECTOR), function(img){
      if (img.dataset.rsBundleFallbackBound !== '1') {
        img.dataset.rsBundleFallbackBound = '1';
        img.addEventListener('error', function(){ fixImage(img); }, true);
      }
      if (img.complete && img.naturalWidth === 0) fixImage(img);
    });
  }

  function init(){
    bind(document);
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        Array.prototype.forEach.call(m.addedNodes || [], function(node){
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SELECTOR)) bind({ querySelectorAll: function(){ return [node]; } });
          bind(node);
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    var tries = 0;
    var scanTimer = setInterval(function(){
      bind(document);
      tries++;
      if (tries >= 60) clearInterval(scanTimer);
    }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();